import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import { Link, useParams } from "react-router-dom";
import PageTitle from "../PageTitle";
import { ContentLoader, NoRecords } from "../Shimmer";
import { DateFormater } from "../GlobalFunctions";

const ProjectInspectionList = () => {

    const { project_id } = useParams();
    const { apiURL, apiHeaderJson, } = useContext(ConfigContext)
    const [inspectionData, setInspectionData] = useState([]);
    const [loadingList, setloadingList] = useState(true);
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const GetList = () => {
        const headers = apiHeaderJson;
        try {
            axios.get(`${apiURL}api/GetProjectVisits`, { params: { project_id }, headers })
                .then((response) => {
                    const { data, success } = response.data;

                    if (success) {
                        setInspectionData(data);
                    }
                });
        } catch (error) {
            console.log(error);
        } finally {
            setloadingList(false);
        }
    }

    const handlePrev = () => {
        if (prev) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNext = () => {
        if (next) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10));
    };

    useEffect(() => {
        GetList();
    }, [project_id]);

    return (
        <>
            <div className="main-content">
                <div className="page-content">
                    {loadingList === false ? (
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Inspections List`} primary={`Home`} />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        {/* <div
                                            className='card-header align-items-center d-flex justify-content-between'
                                            style={{
                                                background: "#000000",
                                            }}>
                                            <h4 className='card-title mb-0 text-white'>Inspections List</h4>

                                            <Link to={`/ProjectInspection/${project_id}`} className="btn btn-light rounded-circle">
                                                <i className="ri-add-line fs-16"></i>
                                            </Link>
                                        </div> */}

                                        <div style={{ background: "#000000" }} className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="mb-0 text-white">Project Inspection</h5>

                                            <Link to={`/ProjectInspection/${project_id}`} className="btn btn-light rounded-circle">
                                                <i className="ri-add-line fs-16"></i>
                                            </Link>
                                        </div>
                                        {/* <div className="card-header" style={{ border: "none" }}>
                                            <div className="row mb-3 justify-content-end">
                                                <div className="col-md-2">
                                                    <div className="dropdown">
                                                        <button type="button" className="btn btn-light btn-label waves-effect waves-light " id="dropdownMenuLink4" data-bs-toggle="dropdown" aria-expanded="true"
                                                        >
                                                            <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                                            Download Report
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                                                            </li>
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                                                                <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                                                                </li>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="card-body">
                                            <div className="table-responsive table-card">
                                                <table
                                                    className={`table table-bordered table-stripped table-nowrap mb-0`}
                                                >
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-center">ID</th>
                                                            <th className="text-center">Visit By</th>
                                                            <th className="text-center">Visit Remark</th>
                                                            <th className="text-center">Visit Date</th>
                                                        </tr>
                                                    </thead>
                                                    {inspectionData.length !== 0 ? (
                                                        <tbody>
                                                            {inspectionData.map((row) => (
                                                                <tr key={row.project_visit_id} className="text-center">
                                                                    <td className="text-center">{row.project_visit_id}</td>
                                                                    <td className="text-center">{row.profile_name}</td>
                                                                    <td className="text-center">{row.visit_remark}</td>
                                                                    <td className="text-center">{DateFormater(row.visit_datetime)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>

                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="4">
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                    <tfoot className="table-light">
                                                        <tr>
                                                            <th colSpan={6}>
                                                                <div className="d-flex justify-content-between">
                                                                    <button
                                                                        disabled={
                                                                            prev === false && loadingList === false
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        type="button"
                                                                        onClick={() => handlePrev()}
                                                                        className={`btn btn-warning btn-label waves-effect waves-light`}
                                                                    >
                                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                                                        Previous
                                                                    </button>
                                                                    <div
                                                                        className="col-md-4"
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {
                                                                            <small>
                                                                                Total Records: {totalRecords} | Total
                                                                                Pages: {totalPages} | Current Page:{" "}
                                                                                {page}
                                                                            </small>
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <select
                                                                            className="form-select"
                                                                            onChange={(e) => handleChange(e)}
                                                                        >
                                                                            {Array.from(
                                                                                { length: totalPages },
                                                                                (_, i) => (
                                                                                    <option
                                                                                        key={i + 1}
                                                                                        selected={page === i + 1}
                                                                                        value={i + 1}
                                                                                    >
                                                                                        {i + 1}
                                                                                    </option>
                                                                                )
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                    <button
                                                                        disabled={
                                                                            next === false && loadingList === false
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        type="button"
                                                                        onClick={() => handleNext()}
                                                                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                                    >
                                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                                                        Next
                                                                    </button>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <ContentLoader />
                    )}
                </div>
            </div >
        </>
    )
}

export default ProjectInspectionList